export default {
  companyName: 'חוגרי ציות תפעול ובקרה בע"מ',
  companyEnglishName: 'Hogery Control & Compliance Ltd',
  title: 'חוגרי ציות תפעול ובקרה - טפסים חכמים'
};
